const UIDO_SITE_URL = "https://uido.pl";
const UIDO_CALENDLY_URL =
  "https://calendly.com/uidopl/bezplatna-konsultacja?primary_color=cc4429";
const UIDO_CONTACT_EMAIL = "kontakt@uido.pl";
const UIDO_PHONE_DISPLAY = "+48 516 720 692";
const UIDO_PHONE_DIGITS = "48516720692";
const UIDO_WHATSAPP_URL = `https://wa.me/${UIDO_PHONE_DIGITS}?text=${encodeURIComponent(
  "Cześć! Chciał_bym umówić się na konsultację z UIDO."
)}`;

export const UIDO_EMAIL_BRAND = {
  meta: {
    name: "UIDO",
    descriptor: "ReDESIGN Selektywny",
    siteUrl: UIDO_SITE_URL,
    defaultLang: "pl",
    supportedLanguages: ["pl", "en"],
    availableLanguageLabel: ["Polish", "English"],
  },
  services: [
    "UX/UI Design",
    "Branding",
    "Web Development",
    "Front-End",
    "Selective Redesign",
  ],
  plans: ["Basic", "Plus", "Focus", "Nexus"],
  colors: {
    blueCalm: "#A5D8FF",
    bottleElegant: "#111E19",
    bottleLight: "#1B3325",
    creme: "#EFE8DD",
    elegantSpace: "#0A1611",
    gray: "#D9D9D9",
    greenLight: "#40F99B",
    uidOrange: "#CC4429",
    uidOrangeLight: "#FF9459",
    white: "#EFE8DD",
    yellow: "#FFD400",
  },
  typography: {
    body: {
      family: '"Montserrat", Arial, Helvetica, sans-serif',
      weightRegular: 500,
      weightBold: 700,
    },
    display: {
      family: '"Unbounded", "Montserrat", Arial, Helvetica, sans-serif',
      weightLight: 300,
      weightMedium: 500,
      weightBold: 700,
    },
    emailFallbacks: {
      body: "Arial, Helvetica, sans-serif",
      heading: "Arial, Helvetica, sans-serif",
    },
    guidance: [
      "Use Montserrat for body copy, navigation-style labels, and CTA text.",
      "Use Unbounded only for short display headings; most email clients will fall back to Montserrat or Arial.",
      "Prefer 300, 500, and 700 font weights to stay close to the website system.",
      "Uppercase works best for short labels, buttons, and section eyebrows.",
    ],
  },
  assets: {
    logos: {
      primary: `${UIDO_SITE_URL}/logo.svg`,
      icon: `${UIDO_SITE_URL}/logo_2.svg`,
    },
    localSource: {
      primary: "/public/logo.svg",
      icon: "/public/logo_2.svg",
    },
    favicon: `${UIDO_SITE_URL}/logo_2.svg`,
  },
  contact: {
    email: UIDO_CONTACT_EMAIL,
    mailtoConsultation:
      "mailto:kontakt@uido.pl?subject=Konsultacja%20z%20UIDO&body=Cze%C5%9B%C4%87!%20Chcia%C5%82_bym%20um%C3%B3wi%C4%87%20si%C4%99%20na%20konsultacj%C4%99%20z%20UIDO.",
    phoneDisplay: UIDO_PHONE_DISPLAY,
    phoneDigits: UIDO_PHONE_DIGITS,
    whatsapp: UIDO_WHATSAPP_URL,
    calendly: UIDO_CALENDLY_URL,
    social: {
      instagram: "https://www.instagram.com/uido.pl/",
      facebook:
        "https://www.facebook.com/profile.php?id=61577222473475&locale=pl_PL",
      linkedin: "https://www.linkedin.com/company/uido",
      behance: "https://www.behance.net/uido",
    },
  },
  voice: {
    traits: [
      "Direct and confident.",
      "Helpful, strategic, and practical.",
      "No fluff and no theory for theory's sake.",
      "Strong first impression, but never corporate for the sake of it.",
    ],
    pl: {
      eyebrow: "UIDO • BRANDING • UX/UI • FRONT-END",
      headline: "UIDO - Twój partner od projektowania",
      ctaPrimary: "Umów bezpłatną konsultację",
      ctaSecondary: "Odwiedź uido.pl",
      signoff: "UIDO • ReDESIGN Selektywny",
      preheader:
        "UIDO • branding, UX/UI i development dla firm, które chcą lepszych wyników.",
      subjectPrefix: "UIDO |",
    },
    en: {
      eyebrow: "UIDO • BRANDING • UX/UI • FRONT-END",
      headline: "UIDO - Your design partner",
      ctaPrimary: "Book a free consultation",
      ctaSecondary: "Visit uido.pl",
      signoff: "UIDO • Selective Redesign",
      preheader:
        "UIDO • branding, UX/UI and development for companies that want better results.",
      subjectPrefix: "UIDO |",
    },
  },
  copyPatterns: {
    pl: {
      subjectExamples: [
        "UIDO | Krótka aktualizacja projektu",
        "UIDO | 3 szybkie usprawnienia dla Twojej strony",
        "UIDO | Umówmy bezpłatną konsultację",
      ],
      preheaderExamples: [
        "Konkrety, które poprawią pierwsze wrażenie i użyteczność.",
        "Krótko pokazujemy, gdzie Twoja komunikacja może działać lepiej.",
        "Branding, UX/UI i development bez zbędnej teorii.",
      ],
    },
    en: {
      subjectExamples: [
        "UIDO | A quick project update",
        "UIDO | 3 practical improvements for your website",
        "UIDO | Let’s book a free consultation",
      ],
      preheaderExamples: [
        "Practical improvements for first impression and usability.",
        "A short note on where your communication can work harder.",
        "Branding, UX/UI and development without the fluff.",
      ],
    },
  },
  layout: {
    maxWidth: 640,
    outerPadding: 24,
    sectionGap: 24,
    cardRadius: 22,
    cardPadding: 32,
    eyebrowTracking: "0.18em",
    linkTracking: "0.09em",
    buttonRadius: 999,
  },
  emailGuidance: {
    rules: [
      "Use a dark bottle-green canvas first. Most sections should sit on #111E19 or #0A1611.",
      "Keep text warm and high-contrast: #EFE8DD for body copy, #A5D8FF for labels, #FF9459 for links and CTA accents.",
      "For safest rendering, prefer tables and inline styles over modern CSS layout.",
      "Do not rely on hover, animation, or SVG-as-CSS tricks in email. Use simple, static blocks instead.",
      "The website button is a ghost CTA with blue border and orange text. Keep that as the primary email button style when deliverability constraints allow it.",
      "If a client strips borders or custom fonts, fall back to a solid orange button and Arial.",
    ],
    contentBlocks: [
      "Eyebrow label",
      "Short display headline",
      "One practical paragraph",
      "One high-clarity CTA",
      "Compact proof or service list",
      "Simple footer with logo, contact email, and site link",
    ],
  },
};

export const UIDO_EMAIL_STYLES = {
  body: {
    margin: "0",
    padding: "0",
    backgroundColor: UIDO_EMAIL_BRAND.colors.bottleElegant,
    color: UIDO_EMAIL_BRAND.colors.creme,
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
  },
  preheader: {
    display: "none",
    maxHeight: "0",
    maxWidth: "0",
    opacity: "0",
    overflow: "hidden",
    msoHide: "all",
    visibility: "hidden",
  },
  outer: {
    width: "100%",
    backgroundColor: UIDO_EMAIL_BRAND.colors.bottleElegant,
    padding: "24px 12px",
  },
  card: {
    width: "100%",
    maxWidth: "640px",
    margin: "0 auto",
    backgroundColor: UIDO_EMAIL_BRAND.colors.elegantSpace,
    border: `1px solid ${rgba(UIDO_EMAIL_BRAND.colors.blueCalm, 0.22)}`,
    borderRadius: "22px",
  },
  inner: {
    padding: "32px",
  },
  headerRow: {
    paddingBottom: "24px",
  },
  logo: {
    display: "block",
    width: "132px",
    maxWidth: "132px",
    height: "auto",
    border: "0",
  },
  eyebrow: {
    margin: "0 0 16px",
    color: UIDO_EMAIL_BRAND.colors.blueCalm,
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "12px",
    fontWeight: "700",
    lineHeight: "16px",
    letterSpacing: UIDO_EMAIL_BRAND.layout.eyebrowTracking,
    textTransform: "uppercase",
  },
  headline: {
    margin: "0 0 16px",
    color: UIDO_EMAIL_BRAND.colors.creme,
    fontFamily: UIDO_EMAIL_BRAND.typography.display.family,
    fontSize: "34px",
    fontWeight: "300",
    lineHeight: "1.2",
  },
  intro: {
    margin: "0 0 20px",
    color: UIDO_EMAIL_BRAND.colors.creme,
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "28px",
  },
  paragraph: {
    margin: "0 0 16px",
    color: UIDO_EMAIL_BRAND.colors.creme,
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "15px",
    fontWeight: "500",
    lineHeight: "27px",
  },
  muted: {
    margin: "0",
    color: rgba(UIDO_EMAIL_BRAND.colors.creme, 0.72),
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "24px",
  },
  link: {
    color: UIDO_EMAIL_BRAND.colors.uidOrangeLight,
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "15px",
    fontWeight: "700",
    lineHeight: "27px",
    letterSpacing: UIDO_EMAIL_BRAND.layout.linkTracking,
    textTransform: "uppercase",
    textDecoration: "none",
  },
  divider: {
    borderTop: `1px solid ${rgba(UIDO_EMAIL_BRAND.colors.blueCalm, 0.22)}`,
    fontSize: "0",
    lineHeight: "0",
  },
  list: {
    margin: "0",
    padding: "0 0 0 18px",
    color: UIDO_EMAIL_BRAND.colors.creme,
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "15px",
    fontWeight: "500",
    lineHeight: "27px",
  },
  ghostButton: {
    display: "inline-block",
    padding: "15px 24px",
    border: `1px solid ${UIDO_EMAIL_BRAND.colors.blueCalm}`,
    borderRadius: "999px",
    color: UIDO_EMAIL_BRAND.colors.uidOrangeLight,
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "15px",
    fontWeight: "700",
    lineHeight: "19px",
    letterSpacing: "0.09em",
    textTransform: "uppercase",
    textDecoration: "none",
    backgroundColor: "transparent",
  },
  solidButton: {
    display: "inline-block",
    padding: "15px 24px",
    border: `1px solid ${UIDO_EMAIL_BRAND.colors.uidOrangeLight}`,
    borderRadius: "999px",
    color: UIDO_EMAIL_BRAND.colors.elegantSpace,
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "15px",
    fontWeight: "700",
    lineHeight: "19px",
    letterSpacing: "0.09em",
    textTransform: "uppercase",
    textDecoration: "none",
    backgroundColor: UIDO_EMAIL_BRAND.colors.uidOrangeLight,
  },
  chip: {
    display: "inline-block",
    padding: "6px 10px",
    borderRadius: "999px",
    backgroundColor: rgba(UIDO_EMAIL_BRAND.colors.uidOrange, 0.18),
    color: UIDO_EMAIL_BRAND.colors.uidOrangeLight,
    border: `1px solid ${rgba(UIDO_EMAIL_BRAND.colors.uidOrangeLight, 0.24)}`,
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "12px",
    fontWeight: "700",
    lineHeight: "16px",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
  footer: {
    paddingTop: "24px",
  },
  footerText: {
    margin: "0 0 8px",
    color: rgba(UIDO_EMAIL_BRAND.colors.creme, 0.72),
    fontFamily: UIDO_EMAIL_BRAND.typography.body.family,
    fontSize: "13px",
    fontWeight: "500",
    lineHeight: "22px",
  },
};

export const UIDO_EMAIL_SNIPPETS = {
  logoHtml: `<img src="${UIDO_EMAIL_BRAND.assets.logos.primary}" alt="UIDO" style="${toInlineStyle(
    UIDO_EMAIL_STYLES.logo
  )}" />`,
  dividerHtml: `<div style="${toInlineStyle(
    UIDO_EMAIL_STYLES.divider
  )}">&nbsp;</div>`,
  footerHtml: buildUidoFooter(),
  signatureHtml: buildUidoSignature(),
};

export function toInlineStyle(styleObject) {
  return Object.entries(styleObject)
    .map(([property, value]) => `${camelToKebab(property)}:${value}`)
    .join(";");
}

export function buildUidoGhostButton(label, href = UIDO_CALENDLY_URL) {
  return `<a href="${escapeHtml(href)}" style="${toInlineStyle(
    UIDO_EMAIL_STYLES.ghostButton
  )}">${escapeHtml(label)}</a>`;
}

export function buildUidoSolidButton(label, href = UIDO_CALENDLY_URL) {
  return `<a href="${escapeHtml(href)}" style="${toInlineStyle(
    UIDO_EMAIL_STYLES.solidButton
  )}">${escapeHtml(label)}</a>`;
}

export function buildUidoSignature({
  name = "UIDO",
  descriptor = UIDO_EMAIL_BRAND.meta.descriptor,
  email = UIDO_EMAIL_BRAND.contact.email,
  siteUrl = UIDO_EMAIL_BRAND.meta.siteUrl,
} = {}) {
  return `
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
      <tr>
        <td style="${toInlineStyle(UIDO_EMAIL_STYLES.footer)}">
          <img src="${UIDO_EMAIL_BRAND.assets.logos.primary}" alt="${escapeHtml(
            name
          )}" style="${toInlineStyle(UIDO_EMAIL_STYLES.logo)}" />
          <p style="${toInlineStyle({
            ...UIDO_EMAIL_STYLES.footerText,
            margin: "16px 0 8px",
          })}">
            ${escapeHtml(name)} • ${escapeHtml(descriptor)}
          </p>
          <p style="${toInlineStyle(UIDO_EMAIL_STYLES.footerText)}">
            <a href="mailto:${escapeHtml(
              email
            )}" style="${toInlineStyle({
              ...UIDO_EMAIL_STYLES.link,
              textTransform: "none",
              letterSpacing: "0",
            })}">
              ${escapeHtml(email)}
            </a>
          </p>
          <p style="${toInlineStyle(UIDO_EMAIL_STYLES.footerText)}">
            <a href="${escapeHtml(siteUrl)}" style="${toInlineStyle({
              ...UIDO_EMAIL_STYLES.link,
              textTransform: "none",
              letterSpacing: "0",
            })}">
              ${escapeHtml(siteUrl.replace(/^https?:\/\//, ""))}
            </a>
          </p>
        </td>
      </tr>
    </table>
  `.trim();
}

export function buildUidoFooter() {
  return `
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
      <tr>
        <td style="${toInlineStyle(UIDO_EMAIL_STYLES.footer)}">
          <div style="${toInlineStyle({
            ...UIDO_EMAIL_STYLES.divider,
            marginBottom: "24px",
          })}">&nbsp;</div>
          ${buildUidoSignature()}
        </td>
      </tr>
    </table>
  `.trim();
}

export function buildUidoEmailShell({
  lang = "pl",
  subject = "",
  preheader,
  eyebrow,
  headline,
  intro,
  bodyHtml = "",
  ctaLabel,
  ctaUrl = UIDO_CALENDLY_URL,
  buttonVariant = "ghost",
  footerHtml = buildUidoFooter(),
} = {}) {
  const voice = UIDO_EMAIL_BRAND.voice[lang] || UIDO_EMAIL_BRAND.voice.pl;
  const resolvedPreheader = preheader || voice.preheader;
  const resolvedEyebrow = eyebrow || voice.eyebrow;
  const resolvedHeadline =
    headline || subject || voice.headline || UIDO_EMAIL_BRAND.meta.name;
  const resolvedIntro = intro || "";
  const resolvedCtaLabel = ctaLabel || voice.ctaPrimary;
  const buttonHtml =
    buttonVariant === "solid"
      ? buildUidoSolidButton(resolvedCtaLabel, ctaUrl)
      : buildUidoGhostButton(resolvedCtaLabel, ctaUrl);

  return `
<!DOCTYPE html>
<html lang="${escapeHtml(lang)}">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="x-ua-compatible" content="ie=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>${escapeHtml(resolvedHeadline)}</title>
  </head>
  <body style="${toInlineStyle(UIDO_EMAIL_STYLES.body)}">
    <div style="${toInlineStyle(UIDO_EMAIL_STYLES.preheader)}">
      ${escapeHtml(resolvedPreheader)}
    </div>
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="${toInlineStyle(
      UIDO_EMAIL_STYLES.outer
    )}">
      <tr>
        <td align="center">
          <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="${toInlineStyle(
            UIDO_EMAIL_STYLES.card
          )}">
            <tr>
              <td style="${toInlineStyle(UIDO_EMAIL_STYLES.inner)}">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
                  <tr>
                    <td style="${toInlineStyle(UIDO_EMAIL_STYLES.headerRow)}">
                      ${UIDO_EMAIL_SNIPPETS.logoHtml}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p style="${toInlineStyle(UIDO_EMAIL_STYLES.eyebrow)}">
                        ${escapeHtml(resolvedEyebrow)}
                      </p>
                      <h1 style="${toInlineStyle(UIDO_EMAIL_STYLES.headline)}">
                        ${escapeHtml(resolvedHeadline)}
                      </h1>
                      ${
                        resolvedIntro
                          ? `<p style="${toInlineStyle(
                              UIDO_EMAIL_STYLES.intro
                            )}">${escapeHtml(resolvedIntro)}</p>`
                          : ""
                      }
                      ${bodyHtml}
                      <div style="padding-top:8px;">
                        ${buttonHtml}
                      </div>
                      ${footerHtml}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`.trim();
}

function camelToKebab(property) {
  return property.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`);
}

function escapeHtml(value) {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

function rgba(hex, alpha) {
  const normalized = hex.replace("#", "");
  const full =
    normalized.length === 3
      ? normalized
          .split("")
          .map((char) => `${char}${char}`)
          .join("")
      : normalized;
  const red = Number.parseInt(full.slice(0, 2), 16);
  const green = Number.parseInt(full.slice(2, 4), 16);
  const blue = Number.parseInt(full.slice(4, 6), 16);

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

export default UIDO_EMAIL_BRAND;
